import request from '@/utils/request'

/**
 * 查询项目
 * @param {Object} params 
 * @returns 
 */
export function listProject(params) {
  return request({
    url: '/project/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询项目
 * @param {Object} params 
 * @returns 
 */
export function authProjectList(params) {
  return request({
    url: '/project/authList',
    method: 'GET',
    params,
  })
}


/**
 * 添加项目
 * @param {Object} data 
 * @returns 
 */
export function addProject(data) {
  return request({
    url: '/project/add',
    method: 'POST',
    data,
  })
}


/**
 * 修改项目
 * @param {Object} data 
 * @returns 
 */
export function updateProject(data) {
  return request({
    url: '/project/update',
    method: 'PUT',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function delProject(data) {
  return request({
    url: '/project/del',
    method: 'DELETE',
    data,
  })
}


/**
 * 根据项目id查询项目信息
 * @param {Object} data 
 * @returns 
 */
export function getProjectById(params) {
  return request({
    url: '/project/findById',
    method: 'get',
    params,
  })
}

